<div [formGroup]="tempFormGroup" class="main-div position-relative">
  @if (currentConfig?.info) {
    <div class="d-flex align-items-center">
      <span class="py-2 info"
        ><i class="fa fa-info-circle px-2 d-inline-block"></i></span
      ><span class="info">{{ currentConfig?.info }}</span>
    </div>
  }
  @if (
    !currentConfig?.dictKeyConfig?.isMultiSelect ||
    currentConfig?.dictKeyConfig?.enableSelectAll ||
    isCascadeMode()
  ) {
    <div
      class="d-flex gap-2 dynamic-dict-title px-3"
      [title]="currentConfig.displayText || currentConfig.property"
      [ngClass]="{
        'no-controls-title': formArray?.controls?.length === 0,
        'error-title': isParentPropertyInvalid(),
      }"
    >
      @if (currentConfig.displayText) {
        <span
          >{{ currentConfig.displayText
          }}{{ currentConfig?.validators?.required ? " *" : "" }}</span
        >
      }
      @if (!readOnly && currentConfig?.order && formArray?.value?.length > 1) {
        <i
          class="ms-2 fa fa-sort cursor-pointer toggle-drag-drop-icon"
          (click)="toggleDragDropControl()"
        ></i>
      }
      <ra-tooltip [tooltipConfig]="currentConfig?.tooltipConfig"></ra-tooltip>
    </div>
  }
  <div>
    @if (isInheritedKeysMode()) {
      <!-- Inherited-keys mode: keys are LOCKED to a source dict's columns; render
           one fixed-label row per inherited column with a value multi-select. -->
      @if (inheritedColumns?.length === 0) {
        <div class="px-3 py-2 cascade-empty-hint">
          Pick one or more subset column(s) above to fill in this previous run's
          value(s).
        </div>
      }
      @for (column of inheritedColumns; track column.name) {
        <div
          class="dynamic-dict-controls inherited-row d-flex align-items-center me-2 gap-2"
        >
          <span class="inherited-column-label" [title]="column.name">
            {{ column.name }}
          </span>
          <mat-form-field
            class="multi-select"
            [title]="getInheritedColumnTitle(column)"
          >
            <mat-select
              [disableOptionCentering]="true"
              #inheritedMatSelect
              [multiple]="true"
              [formControl]="column.control"
              [disabled]="isDisabled"
              (opened)="refreshInheritedValueOptions(column)"
            >
              <mat-select-trigger>
                @if (column.optionConfig?.loading) {
                  <mat-spinner [diameter]="25"></mat-spinner>
                }
                @if (!column.optionConfig?.loading) {
                  <div class="selected-values">
                    @for (value of column.control.value || []; track value) {
                      <span class="selected-value">{{ value }}</span>
                    }
                  </div>
                }
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search
                  placeholderLabel="Search..."
                  noEntriesFoundLabel="No search results"
                  [formControl]="filterCtrl"
                ></ngx-mat-select-search>
              </mat-option>
              @if (column.optionConfig?.loading) {
                <mat-option class="dropdown-loading pointer-events-none">
                  <mat-spinner [diameter]="25"></mat-spinner>
                </mat-option>
              }
              @for (
                value of getInheritedValueOptionsToShow(column)
                  | filter: searchTerm : column.optionConfig?.dropdownLabel;
                track value
              ) {
                <mat-option
                  [disabled]="isDisabled"
                  [value]="
                    column.optionConfig?.dropdownID
                      ? value[column.optionConfig.dropdownID]?.toString()
                      : value?.toString()
                  "
                >
                  {{
                    column.optionConfig?.dropdownLabel
                      ? value[column.optionConfig.dropdownLabel]?.toString()
                      : value?.toString()
                  }}
                </mat-option>
              }
              <!-- Preserve current selection(s) in the option list even if not
                   in the freshly-fetched list yet (e.g. just-hydrated row). -->
              @for (val of column.control.value || []; track val) {
                <mat-option style="height: 0; display: none" [value]="val">
                  {{ val }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
    } @else if (isCascadeMode()) {
      <!-- Cascade mode: expose the top-level Add New only until the first
           breakpoint row/dropdowns are visible. -->
      @if (shouldShowCascadeInitialAddNew()) {
        <button
          type="button"
          class="add-new add-new-btn"
          [ngClass]="{ 'read-only': isDisabled }"
          [disabled]="isDisabled"
          title="Add the first breakpoint row"
          (click)="$event.stopPropagation(); addInitialCascadeRow()"
        >
          <span class="add-new-label">Add New</span>
          <i class="fa fa-plus-circle add-new-icon" aria-hidden="true"></i>
        </button>
      } @else {
        <!-- Cascade is on but levels haven't materialized. Two sub-cases:
             (a) no columns picked yet → ask the user to pick one;
             (b) columns ARE picked but the source-control subscription
                 hasn't propagated yet → ``ngDoCheck`` recovery will heal it
                 on the next change-detection tick, so render no hint. -->
        @if (shouldShowCascadeEmptyHint()) {
          <div class="px-3 py-2 cascade-empty-hint">
            Pick one or more columns above to define buckets per group.
          </div>
        }
      }
    } @else if (formArray?.controls?.length === 0) {
      <button
        type="button"
        class="add-new add-new-btn"
        [ngClass]="{ 'read-only': isDisabled }"
        [disabled]="isDisabled"
        title="Add the first row"
        (click)="$event.stopPropagation(); add(0)"
      >
        <span class="add-new-label">Add New</span>
        <i class="fa fa-plus-circle add-new-icon" aria-hidden="true"></i>
      </button>
    }
    @if (
      currentConfig?.dictKeyConfig?.isMultiSelect &&
      !currentConfig?.dictKeyConfig?.enableSelectAll &&
      !isCascadeMode() &&
      !isInheritedKeysMode()
    ) {
      <mat-form-field
        class="multi-select"
        [title]="
          getSelectedValueTitle(
            getCustomKeyControl(),
            currentConfig?.dictKeyConfig
          )
        "
        [floatLabel]="
          currentConfig?.tooltipConfig?.tooltipDesc ? 'always' : 'auto'
        "
      >
        <ng-template
          raMatLabelTooltip
          [tooltipConfig]="currentConfig?.tooltipConfig"
        ></ng-template>
        <mat-label [title]="currentConfig.displayText || ''">
          {{
            currentConfig.displayText +
              (currentConfig?.validators?.required ? " *" : "") ||
              currentConfig.property
          }}
        </mat-label>
        <div class="d-flex">
          @if (
            currentConfig?.dictKeyConfig?.uiControlType ===
            uiControlType.Dropdown
          ) {
            <mat-select
              [disableOptionCentering]="true"
              #matSelect
              [multiple]="true"
              [formControlName]="customKey"
              (opened)="
                getDropdownValues(currentConfig?.dictKeyConfig, matSelect)
              "
              [ngClass]="{
                'read-only':
                  readOnly ||
                  currentConfig?.orderOnly ||
                  currentConfig?.readOnly,
              }"
            >
              <mat-select-trigger>
                @if (showSpinnerForDropdown) {
                  <mat-spinner [diameter]="25"></mat-spinner>
                }
                @if (!showSpinnerForDropdown) {
                  <div class="selected-values">
                    @for (
                      value of getSelectedValueTitle(
                        getCustomKeyControl(),
                        currentConfig?.dictKeyConfig
                      );
                      track value
                    ) {
                      <span class="selected-value">{{ value }}</span>
                    }
                  </div>
                }
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search
                  placeholderLabel="Search..."
                  noEntriesFoundLabel="No search results"
                  [formControl]="filterCtrl"
                ></ngx-mat-select-search>
              </mat-option>
              @if (currentConfig?.dictKeyConfig?.loading) {
                <mat-option class="dropdown-loading pointer-events-none">
                  <mat-spinner [diameter]="25"></mat-spinner>
                </mat-option>
              }
              @for (
                value of currentConfig?.dictKeyConfig?.values ?? []
                  | filter
                    : searchTerm
                    : currentConfig?.dictKeyConfig?.dropdownLabel;
                track value
              ) {
                <mat-option
                  [disabled]="isDisabled"
                  [value]="
                    currentConfig?.dictKeyConfig.dropdownID
                      ? value[
                          currentConfig?.dictKeyConfig.dropdownID
                        ]?.toString()
                      : value?.toString()
                  "
                >
                  {{
                    currentConfig?.dictKeyConfig.dropdownLabel
                      ? value[
                          currentConfig?.dictKeyConfig.dropdownLabel
                        ]?.toString()
                      : value?.toString()
                  }}
                </mat-option>
              }
              @for (
                val of (tempFormGroup.get(customKey)?.value ?? []).sort(
                  compareValues
                );
                track val
              ) {
                <mat-option style="height: 0; display: none" [value]="val">
                  {{ val }}
                </mat-option>
              }
            </mat-select>
          }
        </div>
      </mat-form-field>
    }
    <!-- Multi-select with Select/Deselect All, Unique across rows features keys container -->
    @if (
      currentConfig?.dictKeyConfig?.isMultiSelect &&
      currentConfig?.dictKeyConfig?.enableSelectAll &&
      currentConfig?.dictKeyConfig?.uiControlType === uiControlType.Dropdown &&
      !isInheritedKeysMode()
    ) {
      @for (control of formArray?.controls; track control; let i = $index) {
        <div
          [formArrayName]="customKey"
          class="dynamic-dict-controls d-flex align-items-center me-2"
        >
          <mat-form-field
            class="multi-select"
            [title]="
              getSelectedValueTitle(
                asFormControl(control),
                currentConfig.dictKeyConfig
              )
            "
          >
            <mat-select
              [disableOptionCentering]="true"
              #matSelectRow
              [multiple]="true"
              [formControlName]="i"
              (opened)="
                getDropdownValues(currentConfig.dictKeyConfig, matSelectRow)
              "
              [ngClass]="{
                'read-only':
                  readOnly ||
                  currentConfig?.orderOnly ||
                  currentConfig?.readOnly,
              }"
              [disabled]="isDisabled"
            >
              <mat-select-trigger>
                @if (showSpinnerForDropdown) {
                  <mat-spinner [diameter]="25"></mat-spinner>
                }
                @if (!showSpinnerForDropdown) {
                  <div class="selected-values">
                    @for (
                      value of getSelectedValueTitle(
                        asFormControl(control),
                        currentConfig.dictKeyConfig
                      );
                      track value
                    ) {
                      <span class="selected-value">{{ value }} </span>
                    }
                  </div>
                }
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search
                  placeholderLabel="Search..."
                  noEntriesFoundLabel="No search results"
                  [formControl]="filterCtrl"
                >
                </ngx-mat-select-search>
              </mat-option>
              @if (currentConfig?.dictKeyConfig?.loading) {
                <mat-option class="dropdown-loading pointer-events-none">
                  <mat-spinner [diameter]="25"></mat-spinner>
                </mat-option>
              }
              @if (!isDisabled && !currentConfig.dictKeyConfig.avoidNone) {
                <mat-option value=""> None </mat-option>
              }
              <!-- Select/Deselect All checkbox -->
              @if (
                !currentConfig?.dictKeyConfig?.loading &&
                currentConfig?.dictKeyConfig?.enableSelectAll
              ) {
                <mat-checkbox
                  class="select-all-checkbox"
                  [checked]="isRowAllSelected(i)"
                  [indeterminate]="isRowIndeterminate(i)"
                  (change)="
                    selectAllToggle(
                      i,
                      $event,
                      currentConfig.dictKeyConfig.enableUniqueRows
                        ? getKeyOptionsForRow(i)
                        : (currentConfig.dictKeyConfig.values ?? [])
                    )
                  "
                  [disabled]="isDisabled"
                >
                  Select/Deselect All
                </mat-checkbox>
              }
              <!-- Options list with uniqueness filtering -->
              @if (currentConfig.dictKeyConfig.enableUniqueRows) {
                @for (
                  value of getKeyOptionsForRow(i)
                    | filter
                      : searchTerm
                      : currentConfig.dictKeyConfig.dropdownLabel;
                  track value
                ) {
                  <mat-option
                    [disabled]="isDisabled"
                    [value]="
                      currentConfig.dictKeyConfig.dropdownID
                        ? value[
                            currentConfig.dictKeyConfig.dropdownID
                          ]?.toString()
                        : value?.toString()
                    "
                  >
                    {{
                      currentConfig.dictKeyConfig.dropdownLabel
                        ? value[
                            currentConfig.dictKeyConfig.dropdownLabel
                          ]?.toString()
                        : value?.toString()
                    }}
                  </mat-option>
                }
              } @else {
                @for (
                  value of currentConfig.dictKeyConfig.values ?? []
                    | filter
                      : searchTerm
                      : currentConfig.dictKeyConfig.dropdownLabel;
                  track value
                ) {
                  <mat-option
                    [disabled]="isDisabled"
                    [value]="
                      currentConfig.dictKeyConfig.dropdownID
                        ? value[
                            currentConfig.dictKeyConfig.dropdownID
                          ]?.toString()
                        : value?.toString()
                    "
                  >
                    {{
                      currentConfig.dictKeyConfig.dropdownLabel
                        ? value[
                            currentConfig.dictKeyConfig.dropdownLabel
                          ]?.toString()
                        : value?.toString()
                    }}
                  </mat-option>
                }
              }
              <!-- Preserve selection ordering -->
              @for (
                val of (control.value || [])?.sort(compareValues);
                track val
              ) {
                <mat-option style="height: 0; display: none" [value]="val"
                  >{{ val }}
                </mat-option>
              }
            </mat-select>
            <mat-error>
              {{
                control.value === "CREATE NEW"
                  ? dropdownCreateNewErrorMessage[i]
                  : "Please review the field"
              }}
            </mat-error>
          </mat-form-field>
          <!-- Row action buttons -->
          @if (!isDisabled) {
            <div
              class="d-flex align-items-center me-3 dynamic-dict-actions gap-2 flex-shrink-0"
            >
              <i class="dict-actions fa fa-plus" (click)="addRow(i)"></i>
              <i
                class="dict-actions fa fa-trash-alt"
                (click)="deleteRow(i)"
              ></i>
            </div>
          }
          <!-- Value control bound to combined key -->
          @if (currentConfig.dictValuesConfig; as vCfg) {
            @if (getCombinedKeyForRow(i); as vKey) {
              @if (vCfg.valueConfig && getValueFormControl(vKey)) {
                <mat-form-field
                  [ngClass]="
                    vCfg.valueConfig?.uiControlType ===
                      uiControlType.Dropdown && vCfg.valueConfig?.isMultiSelect
                      ? 'multi-select'
                      : ''
                  "
                  [title]="
                    getSelectedValueTitle(
                      getValueFormControl(vKey),
                      vCfg.valueConfig
                    )
                  "
                >
                  <div class="d-flex">
                    @if (!vCfg.valueConfig) {
                      <input
                        matInput
                        [readonly]="isDisabled"
                        [formControl]="getValueFormControl(vKey)"
                      />
                    }
                    @if (
                      vCfg.valueConfig?.uiControlType === uiControlType.Text
                    ) {
                      <input
                        matInput
                        [readonly]="isDisabled"
                        [formControl]="getValueFormControl(vKey)"
                      />
                    }
                    @if (
                      vCfg.valueConfig?.uiControlType === uiControlType.Number
                    ) {
                      <input
                        matInput
                        type="number"
                        [readonly]="isDisabled"
                        [formControl]="getValueFormControl(vKey)"
                      />
                    }
                    @if (
                      vCfg.valueConfig?.uiControlType === uiControlType.Date
                    ) {
                      <input
                        matInput
                        type="date"
                        [readonly]="isDisabled"
                        [formControl]="getValueFormControl(vKey)"
                      />
                    }
                    @if (
                      vCfg.valueConfig?.uiControlType === uiControlType.Dropdown
                    ) {
                      <mat-select
                        [disableOptionCentering]="true"
                        #matSelect
                        [formControl]="getValueFormControl(vKey)"
                        (opened)="
                          getDropdownValues(vCfg.valueConfig, matSelect, vKey)
                        "
                        [multiple]="vCfg.valueConfig?.isMultiSelect"
                        [ngClass]="{
                          'read-only':
                            readOnly ||
                            currentConfig?.orderOnly ||
                            currentConfig?.readOnly,
                        }"
                      >
                        <mat-select-trigger>
                          @if (showSpinnerForDropdown) {
                            <mat-spinner [diameter]="25"></mat-spinner>
                          }
                          @if (!showSpinnerForDropdown) {
                            <div class="selected-values">
                              @for (
                                value of getSelectedValueTitle(
                                  getValueFormControl(vKey),
                                  vCfg.valueConfig
                                );
                                track value
                              ) {
                                <span class="selected-value">{{ value }}</span>
                              }
                            </div>
                          }
                        </mat-select-trigger>
                        <mat-option>
                          <ngx-mat-select-search
                            placeholderLabel="Search..."
                            noEntriesFoundLabel="No search results"
                            [formControl]="filterCtrl"
                          ></ngx-mat-select-search>
                        </mat-option>
                        @if (vCfg.valueConfig?.loading) {
                          <mat-option
                            class="dropdown-loading pointer-events-none"
                          >
                            <mat-spinner [diameter]="25"></mat-spinner>
                          </mat-option>
                        }
                        @if (!isDisabled && !vCfg.valueConfig.avoidNone) {
                          <mat-option>None</mat-option>
                        }
                        @for (
                          val of vCfg.valueConfig.values ?? []
                            | filter
                              : searchTerm
                              : vCfg.valueConfig.dropdownLabel;
                          track val
                        ) {
                          <mat-option
                            [value]="
                              vCfg.valueConfig.dropdownID
                                ? val[vCfg.valueConfig.dropdownID]?.toString()
                                : val?.toString()
                            "
                          >
                            {{
                              vCfg.valueConfig.dropdownLabel
                                ? val[vCfg.valueConfig.dropdownLabel]
                                : val
                            }}
                          </mat-option>
                        }
                        @for (
                          val of vCfg.valueConfig.isMultiSelect
                            ? getValueFormControl(vKey)?.value?.sort(
                                compareValues
                              )
                            : [getValueFormControl(vKey)?.value];
                          track val
                        ) {
                          <mat-option
                            style="height: 0; display: none"
                            [value]="val"
                            >{{ val }}</mat-option
                          >
                        }
                      </mat-select>
                    }
                  </div>
                  <mat-error>
                    {{
                      vCfg.valueConfig.errorMessages?.[
                        keys(getValueFormControl(vKey)?.errors)?.[0]
                      ] || "Please review the field"
                    }}
                  </mat-error>
                </mat-form-field>
              }
              <!-- Nested config value -->
              @if (
                vCfg.config && vKey !== "CREATE NEW" && getValueFormGroup(vKey);
                as valueFormGroup
              ) {
                <div class="flex-grow-1 overflow-hidden">
                  <ra-json-dynamic-form
                    class="w-100"
                    [readOnly]="isDisabled"
                    [dynamicDictKey]="vKey"
                    [jsonFormGroup]="valueFormGroup"
                    [uiConfig]="$any(vCfg)"
                  >
                  </ra-json-dynamic-form>
                </div>
              }
            }
          }
        </div>
      }
    }

    <!-- Cascade mode : one row -> N cascading dropdowns + value ctrl. -->
    @if (
      isCascadeMode() &&
      (cascadeLevels?.length ?? 0) > 0 &&
      (formArray?.controls?.length ?? 0) > 0
    ) {
      @for (rowCtl of formArray?.controls; track rowCtl; let i = $index) {
        <div
          class="dynamic-dict-controls cascade-row d-flex align-items-center me-2 gap-2 flex-wrap"
          [class.cascade-row-duplicate]="isRowDuplicateInCascade(i)"
        >
          @if (isRowDuplicateInCascade(i)) {
            <div class="cascade-row-duplicate-warning w-100">
              Conflicting combination — overlaps with a row above (a value at
              every level is also selected there). Records matching this row
              would also match the earlier row, so the bucket assignment is
              ambiguous. Please change one of the cascade values to make this
              row unique.
            </div>
          }
          @for (level of cascadeLevels; track level; let li = $index) {
            <mat-form-field
              [ngClass]="{
                'multi-select': isLevelMultiSelect(),
                'cascade-level': true,
                'disabled-look':
                  isDisabled || (li > 0 && !hasCascadeLevelValue(i, li - 1)),
              }"
              [title]="getCascadeLevelValueTitle(i, li)"
            >
              <mat-label>{{ getCascadeColumnLabel(level) }}</mat-label>
              <mat-select
                [disableOptionCentering]="true"
                #cascadeMatSelect
                [multiple]="isLevelMultiSelect()"
                [formControl]="getCascadeLevelControl(i, li)"
                (opened)="refreshCascadeLevelValues(i, li)"
              >
                @if (isLevelMultiSelect()) {
                  <mat-select-trigger>
                    <div class="selected-values">
                      @for (
                        val of getCascadeLevelValueArray(i, li);
                        track val
                      ) {
                        <span class="selected-value">{{ val }}</span>
                      }
                    </div>
                  </mat-select-trigger>
                }
                <mat-option>
                  <ngx-mat-select-search
                    placeholderLabel="Search..."
                    noEntriesFoundLabel="No search results"
                    [formControl]="filterCtrl"
                  ></ngx-mat-select-search>
                </mat-option>
                @if (level.loading) {
                  <mat-option class="dropdown-loading pointer-events-none">
                    <mat-spinner [diameter]="25"></mat-spinner>
                  </mat-option>
                }
                <!-- Select/Deselect All for cascade-level multi-select -->
                @if (!level.loading && isLevelMultiSelect()) {
                  <mat-checkbox
                    class="select-all-checkbox"
                    [checked]="isCascadeLevelAllSelected(i, li)"
                    [indeterminate]="isCascadeLevelIndeterminate(i, li)"
                    (change)="cascadeSelectAllToggle(i, li, $event)"
                    [disabled]="
                      isDisabled || (li > 0 && !hasCascadeLevelValue(i, li - 1))
                    "
                  >
                    Select/Deselect All
                  </mat-checkbox>
                }
                @for (
                  value of level.values || []
                    | filter: searchTerm : level.dropdownLabel;
                  track value
                ) {
                  <mat-option
                    [disabled]="isDisabled"
                    [value]="
                      level.dropdownID
                        ? value[level.dropdownID]?.toString()
                        : value?.toString()
                    "
                  >
                    {{
                      level.dropdownLabel
                        ? value[level.dropdownLabel]?.toString()
                        : value?.toString()
                    }}
                  </mat-option>
                }
                <!-- Preserve current selection(s) if not in the freshly
                     fetched list yet (e.g. just-hydrated saved row before
                     opening the dropdown). -->
                @for (
                  curVal of getCascadeLevelValueArray(i, li);
                  track curVal
                ) {
                  <mat-option
                    style="height: 0; display: none"
                    [value]="curVal"
                    >{{ curVal }}</mat-option
                  >
                }
              </mat-select>
            </mat-form-field>
          }
          <!-- Row action buttons -->
          @if (!isDisabled) {
            <div
              class="d-flex align-items-center me-3 dynamic-dict-actions gap-2 flex-shrink-0"
            >
              <i class="dict-actions fa fa-plus" (click)="addRow(i)"></i>
              <i
                class="dict-actions fa fa-trash-alt"
                (click)="deleteRow(i)"
              ></i>
            </div>
          }
          <!-- Value control bound to the composite ``a||b`` key for this row -->
          @if (currentConfig.dictValuesConfig; as vCfg) {
            @if (getCombinedKeyForRow(i); as vKey) {
              @if (
                vCfg.config && vKey !== "CREATE NEW" && getValueFormGroup(vKey);
                as valueFormGroup
              ) {
                <div class="flex-grow-1 overflow-hidden">
                  <ra-json-dynamic-form
                    class="w-100"
                    [readOnly]="isDisabled"
                    [dynamicDictKey]="vKey"
                    [jsonFormGroup]="valueFormGroup"
                    [uiConfig]="$any(vCfg)"
                  >
                  </ra-json-dynamic-form>
                </div>
              }
            }
          }
        </div>
      }
    }

    @if ((formArray?.controls?.length ?? 0) > 0) {
      @if (!currentConfig?.dictKeyConfig?.isMultiSelect && !isCascadeMode()) {
        @for (control of formArray?.controls; track control; let i = $index) {
          <div
            [formArrayName]="customKey"
            class="dynamic-dict-controls d-flex align-items-center me-2"
          >
            <mat-form-field [title]="asFormControl(control).value || ''">
              <div class="d-flex">
                @if (!currentConfig?.dictKeyConfig) {
                  <input
                    [readonly]="isDisabled"
                    [ngClass]="{ 'read-only': isDisabled }"
                    matInput
                    [formControlName]="i"
                  />
                }
                @if (
                  currentConfig?.dictKeyConfig?.uiControlType ===
                  uiControlType.Text
                ) {
                  <input
                    [readonly]="isDisabled"
                    [ngClass]="{ 'read-only': isDisabled }"
                    matInput
                    [formControlName]="i"
                  />
                }
                @if (
                  currentConfig?.dictKeyConfig?.uiControlType ===
                  uiControlType.Number
                ) {
                  <input
                    [readonly]="isDisabled"
                    [ngClass]="{ 'read-only': isDisabled }"
                    matInput
                    type="number"
                    [formControlName]="i"
                  />
                }
                @if (
                  currentConfig?.dictKeyConfig?.uiControlType ===
                  uiControlType.Dropdown
                ) {
                  <mat-select
                    [disableOptionCentering]="true"
                    #matSelect
                    [formControlName]="i"
                    (opened)="
                      getDropdownValues(currentConfig?.dictKeyConfig, matSelect)
                    "
                    [ngClass]="{
                      'read-only':
                        readOnly ||
                        currentConfig?.orderOnly ||
                        currentConfig?.readOnly,
                    }"
                  >
                    <mat-select-trigger>
                      @if (showSpinnerForDropdown) {
                        <mat-spinner [diameter]="25"></mat-spinner>
                      }
                      @if (!showSpinnerForDropdown) {
                        <div class="selected-values">
                          <span class="selected-value">{{
                            asFormControl(control).value || ""
                          }}</span>
                        </div>
                      }
                    </mat-select-trigger>
                    <mat-option>
                      <ngx-mat-select-search
                        placeholderLabel="Search..."
                        noEntriesFoundLabel="No search results"
                        [formControl]="filterCtrl"
                      ></ngx-mat-select-search>
                    </mat-option>
                    @if (currentConfig?.dictKeyConfig?.loading) {
                      <mat-option class="dropdown-loading pointer-events-none">
                        <mat-spinner [diameter]="25"></mat-spinner>
                      </mat-option>
                    }
                    @if (
                      !isDisabled && !currentConfig?.dictKeyConfig?.avoidNone
                    ) {
                      <mat-option>None</mat-option>
                    }
                    @if (!currentConfig?.dictKeyConfig?.isGrouped) {
                      @for (
                        value of getSingleSelectKeyOptionsToShow(i)
                          | filter
                            : searchTerm
                            : currentConfig?.dictKeyConfig?.dropdownLabel;
                        track value
                      ) {
                        <mat-option
                          [disabled]="isDisabled"
                          [value]="getKeyOptionStoredValue(value)"
                        >
                          @if (value === "CREATE NEW") {
                            <button
                              class="add-new-option"
                              [disabled]="isDisabled"
                              (click)="openAddNewDialog(i, matSelect)"
                              mat-button
                            >
                              {{ getKeyOptionLabelText(value) }}
                            </button>
                          } @else if (
                            currentConfig?.dictKeyConfig?.optionDisplayFields
                              ?.length
                          ) {
                            <div class="d-flex flex-column">
                              @for (
                                subTxt of currentConfig?.dictKeyConfig
                                  ?.optionDisplayFields;
                                track subTxt;
                                let si = $index
                              ) {
                                <span [ngClass]="'sub-text-' + si">{{
                                  value?.[subTxt]
                                }}</span>
                              }
                            </div>
                          } @else {
                            {{ getKeyOptionLabelText(value) }}
                          }
                        </mat-option>
                      }
                    } @else {
                      @for (
                        group of getSingleSelectKeyOptionsToShow(i);
                        track group?.label
                      ) {
                        <mat-optgroup
                          [label]="group.label | titlecase"
                          [disabled]="isDisabled"
                        >
                          @for (
                            value of group?.options || []
                              | filter
                                : searchTerm
                                : currentConfig?.dictKeyConfig?.dropdownLabel;
                            track value
                          ) {
                            <mat-option
                              [disabled]="isDisabled"
                              [value]="getKeyOptionStoredValue(value)"
                            >
                              @if (
                                currentConfig?.dictKeyConfig
                                  ?.optionDisplayFields?.length
                              ) {
                                <div class="d-flex flex-column">
                                  @for (
                                    subTxt of currentConfig?.dictKeyConfig
                                      ?.optionDisplayFields;
                                    track subTxt;
                                    let si = $index
                                  ) {
                                    <span [ngClass]="'sub-text-' + si">{{
                                      value?.[subTxt]
                                    }}</span>
                                  }
                                </div>
                              } @else {
                                {{ getKeyOptionLabelText(value) }}
                              }
                            </mat-option>
                          }
                        </mat-optgroup>
                      }
                    }
                    <mat-option
                      style="height: 0; display: none"
                      [value]="control?.value"
                    >
                      {{ control?.value }}
                    </mat-option>
                  </mat-select>
                }
              </div>
              <mat-error>
                {{
                  control?.value === "CREATE NEW"
                    ? this.dropdownCreateNewErrorMessage[i]
                    : "Please review the field"
                }}
              </mat-error>
            </mat-form-field>
            @if (!isDisabled && !currentConfig?.dictKeyConfig?.isMultiSelect) {
              <div
                class="d-flex align-items-center me-3 dynamic-dict-actions gap-2 flex-shrink-0"
              >
                <i class="dict-actions fa fa-plus" (click)="add(i)"></i>
                <i class="dict-actions fa fa-trash-alt" (click)="remove(i)"></i>
              </div>
            }
            @if (
              currentConfig?.dictValuesConfig?.valueConfig &&
              getValueFormControl(control.value)
            ) {
              <mat-form-field
                [ngClass]="
                  currentConfig?.dictValuesConfig?.valueConfig
                    ?.uiControlType === uiControlType.Dropdown &&
                  !!currentConfig?.dictValuesConfig?.valueConfig?.isMultiSelect
                    ? 'multi-select'
                    : ''
                "
                [title]="
                  getSelectedValueTitle(
                    getValueFormControl(control.value),
                    currentConfig?.dictValuesConfig?.valueConfig
                  )
                "
              >
                <div class="d-flex">
                  @if (!currentConfig?.dictValuesConfig?.valueConfig) {
                    <input
                      [readonly]="isDisabled"
                      [ngClass]="{ 'read-only': isDisabled }"
                      matInput
                      [formControl]="getValueFormControl(control.value)"
                    />
                  }
                  @if (
                    currentConfig?.dictValuesConfig?.valueConfig
                      ?.uiControlType === uiControlType.Text
                  ) {
                    <input
                      [readonly]="isDisabled"
                      [ngClass]="{ 'read-only': isDisabled }"
                      matInput
                      [formControl]="getValueFormControl(control.value)"
                    />
                  }
                  @if (
                    currentConfig?.dictValuesConfig?.valueConfig
                      ?.uiControlType === uiControlType.Number
                  ) {
                    <input
                      [readonly]="isDisabled"
                      [ngClass]="{ 'read-only': isDisabled }"
                      matInput
                      type="number"
                      [formControl]="getValueFormControl(control.value)"
                    />
                  }
                  @if (
                    currentConfig?.dictValuesConfig?.valueConfig
                      ?.uiControlType === uiControlType.Date
                  ) {
                    <input
                      [readonly]="isDisabled"
                      [ngClass]="{ 'read-only': isDisabled }"
                      matInput
                      type="date"
                      [formControl]="getValueFormControl(control.value)"
                    />
                  }
                  @if (
                    currentConfig?.dictValuesConfig?.valueConfig
                      ?.uiControlType === uiControlType.Dropdown
                  ) {
                    <mat-select
                      [disableOptionCentering]="true"
                      #matSelect
                      [formControl]="getValueFormControl(control.value)"
                      (opened)="
                        getDropdownValues(
                          currentConfig?.dictValuesConfig?.valueConfig,
                          matSelect,
                          control.value
                        )
                      "
                      [multiple]="
                        !!currentConfig?.dictValuesConfig?.valueConfig
                          ?.isMultiSelect
                      "
                      [ngClass]="{
                        'read-only':
                          readOnly ||
                          currentConfig?.orderOnly ||
                          currentConfig?.readOnly,
                      }"
                    >
                      <mat-select-trigger>
                        @if (showSpinnerForDropdown) {
                          <mat-spinner [diameter]="25"></mat-spinner>
                        }
                        @if (!showSpinnerForDropdown) {
                          <div class="selected-values">
                            @for (
                              value of getSelectedValueTitle(
                                getValueFormControl(control.value),
                                currentConfig?.dictValuesConfig?.valueConfig
                              );
                              track value
                            ) {
                              <span class="selected-value">{{ value }}</span>
                            }
                          </div>
                        }
                      </mat-select-trigger>
                      <mat-option>
                        <ngx-mat-select-search
                          placeholderLabel="Search..."
                          noEntriesFoundLabel="No search results"
                          [formControl]="filterCtrl"
                        ></ngx-mat-select-search>
                      </mat-option>
                      @if (
                        currentConfig?.dictValuesConfig?.valueConfig?.loading
                      ) {
                        <mat-option
                          class="dropdown-loading pointer-events-none"
                        >
                          <mat-spinner [diameter]="25"></mat-spinner>
                        </mat-option>
                      }
                      @if (
                        !isDisabled &&
                        !currentConfig?.dictValuesConfig?.valueConfig.avoidNone
                      ) {
                        <mat-option>None </mat-option>
                      }
                      @for (
                        value of currentConfig?.dictValuesConfig?.valueConfig
                          ?.values ?? []
                          | filter
                            : searchTerm
                            : currentConfig?.dictValuesConfig?.valueConfig
                                ?.dropdownLabel;
                        track value
                      ) {
                        <mat-option
                          [disabled]="isDisabled"
                          [value]="
                            currentConfig?.dictValuesConfig?.valueConfig
                              .dropdownID
                              ? value[
                                  currentConfig?.dictValuesConfig?.valueConfig
                                    .dropdownID
                                ]?.toString()
                              : value?.toString()
                          "
                        >
                          {{
                            currentConfig?.dictValuesConfig?.valueConfig
                              .dropdownLabel
                              ? value[
                                  currentConfig?.dictValuesConfig?.valueConfig
                                    .dropdownLabel
                                ]?.toString()
                              : value?.toString()
                          }}
                        </mat-option>
                      }
                      @for (
                        val of currentConfig?.dictValuesConfig?.valueConfig
                          .isMultiSelect
                          ? getValueFormControl(control.value)?.value?.sort(
                              compareValues
                            )
                          : [getValueFormControl(control.value)?.value];
                        track val
                      ) {
                        <mat-option
                          style="height: 0; display: none"
                          [value]="val"
                        >
                          {{ val }}
                        </mat-option>
                      }
                    </mat-select>
                  }
                </div>
                <mat-error>
                  {{
                    currentConfig?.dictValuesConfig?.valueConfig
                      ?.errorMessages?.[
                      keys(getValueFormControl(control.value)?.errors)?.[0]
                    ] || "Please review the field"
                  }}
                </mat-error>
              </mat-form-field>
            }
            @if (
              currentConfig?.dictValuesConfig?.config &&
                control.value !== "CREATE NEW" &&
                getValueFormGroup(control.value);
              as valueFormGroup
            ) {
              <div class="flex-grow-1 overflow-hidden">
                <ra-json-dynamic-form
                  class="w-100"
                  [readOnly]="isDisabled"
                  [dynamicDictKey]="control.value"
                  [jsonFormGroup]="valueFormGroup"
                  [uiConfig]="$any(currentConfig?.dictValuesConfig)"
                >
                </ra-json-dynamic-form>
              </div>
            }
          </div>
        }
      }
    }
  </div>
  @if (isParentPropertyInvalid()) {
    <div class="error-text">{{ getParentPropertyError() }}</div>
  }
</div>
